// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"fe5b7b1d","256":"aaef52b0","292":"76d15466","440":"8f8de8cf","496":"d82b2c88","580":"f1bbe2d9","860":"13a348fd","899":"d2e2e504","900":"7e118fdb"}[chunkId] + ".chunk.js";
};